import { render, staticRenderFns } from "./CustomersMerge.vue?vue&type=template&id=a8834228"
import script from "./CustomersMerge.vue?vue&type=script&lang=js"
export * from "./CustomersMerge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports